import React from 'react';
import PropTypes from 'prop-types';
import Section from '../components/section';

const FacilityBlock = ({ title, icon, items }) => (
  <div className="list-group">
    <div className={`list-icon ${icon[0]}`} />
    <h3 className="title-3">{title}</h3>
    <ul className="list">
      {items.map((item, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <li key={i} className="list-item">
          {item}
        </li>
      ))}
    </ul>
  </div>
);

const Facilities = ({ items }) => (
  <Section title="Удобства">
    <div className="row row--wrap facilities-list">
      {items.slice(0, 4).map(({ node: facility }) => (
        <div key={facility.id} className="col-xs-12 col-sm-6 col-md-3 wow fadeInUp">
          <FacilityBlock {...facility} />
        </div>
      ))}
    </div>
    <div className="row row--wrap facilities-list">
      {items.slice(4, 8).map(({ node: facility }) => (
        <div key={facility.id} className="col-xs-12 col-sm-6 col-md-3 wow fadeInUp">
          <FacilityBlock {...facility} />
        </div>
      ))}
    </div>
  </Section>
);

Facilities.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape).isRequired,
};

FacilityBlock.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.arrayOf(PropTypes.string).isRequired,
  items: PropTypes.arrayOf(PropTypes.shape).isRequired,
};

export default Facilities;
